import { render } from "./UiValidatedJson.pug?vue&type=template&id=4e98f49a&lang=pug"
import script from "./UiValidatedJson.js?vue&type=script&lang=js"
export * from "./UiValidatedJson.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__